<template lang="pug">
  b-field.select-task-status(:label="label")
    b-dropdown(v-model="innerData" @change="changeValue" v-bind="$attrs")
      b-field.has-addons(slot="trigger")
        .control: b-button(icon-right="menu-down")
          task-status(v-if="innerData" :status="innerData")
          span.has-text-grey(v-else) Статус
        .control(v-if="withReset && innerData"): b-button(icon-left="close" @click.stop="changeValue(null)")

      b-dropdown-item(v-for="status in innerOptions" :key="status.id" :value="status")
        task-status(:status="status")
</template>

<script>
import TaskStatus from '@/models/TaskStatus';

export default {
  name: 'select-task-status',

  props: {
    value: [String, Number],
    data: Object,
    label: String,
    filter: Function,
    withReset: Boolean,
  },

  data: () => ({
    taskStatuses: TaskStatus.collection(),
    innerData: null,
  }),

  watch: {
    value(statusId) {
      this.updateInnerData(null, statusId);
    },
  },

  computed: {
    innerOptions() {
      if (this.filter) {
        return this.taskStatuses.items.filter(this.filter);
      }
      return this.taskStatuses.items;
    },
  },

  methods: {
    async loadState() {
      await this.taskStatuses.$fetch();
      this.$emit('onLoadState', this.taskStatuses);
    },

    changeValue(status) {
      this.$emit('input', status ? status.id : null);
      this.$emit('update:data', status);
    },

    updateInnerData(innerData, statusId) {
      if (innerData) {
        this.innerData = innerData;
      } else if (this.taskStatuses) {
        this.innerData = this.taskStatuses.find(statusId);
      }
    },
  },

  async created() {
    this.updateInnerData(this.data);
    if (!this.options) {
      await this.loadState();
    }
    if (!this.data) {
      this.updateInnerData(null, this.value);
    }
  },
};
</script>
